import React from 'react';
import { isEmpty } from '../../../util/isEmpty';
import { formatMoney } from '@shopify/theme-currency';

/**
 * Displays the current cart total price in sync with Shopify
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const CartPrice = ({ shoppingCart, totalPrice, format }) => {
  // shoppingCart.cart is initially undefined, so we are
  // safely accessing cart property using Optional Chaining (?.)
  // and supplying an empty object as a fallback value
  const { cart } = shoppingCart?.get || {};
  const formattedPrice = formatMoney(cart.total_price, format);
  const price = isEmpty(cart) ? totalPrice : formattedPrice;

  return <span>{price}</span>;
};

export default CartPrice;
